export default __webpack_public_path__ + "static/media/URI.e21fabb9.JS";